import { Box, Paper, Stack, Typography } from '@mui/material'
import { Link as RouterLink } from 'react-router-dom'
import DASHBOARD_QUICK_LINKS from '../../_constants/dashboard-quicklinks'

export default function QuickLinksRow() {
  return (
    <Paper variant='outlined' sx={{ p: 1.5, borderRadius: 2 }}>
      <Stack
        direction='row'
        spacing={2}
        sx={{
          overflowX: 'auto',
          alignItems: 'center',
          '&::-webkit-scrollbar': { height: 4 }
        }}
      >
        {DASHBOARD_QUICK_LINKS.map((link, i) => (
          <RouterLink
            key={i}
            to={link.link}
            style={{ textDecoration: 'none', color: 'inherit', flexShrink: 0 }}
          >
            <Box
              display='flex'
              alignItems='center'
              gap={1}
              sx={{
                px: 1.5,
                py: 0.75,
                borderRadius: 1,
                transition: 'background-color 0.2s',
                '&:hover': { backgroundColor: 'action.hover' }
              }}
            >
              {link.icon}
              <Typography variant='body2' fontWeight={500}>
                {link.title}
              </Typography>
            </Box>
          </RouterLink>
        ))}
      </Stack>
    </Paper>
  )
}
